import Cogio from "../../../layouts/apps/Cogio";
import LinkedText from "../../../components/LinkedText";
import {faEnvelope} from "@fortawesome/free-solid-svg-icons";

export default function CogioPrivacyPolicy() {
    const rightContent = (
        <div>
            <p>Cogio is a time tracking app for macOS, developed and maintained by a solo developer (me, Çağrı
                Gökpunar). This Privacy Policy explains how the app handles your data and your privacy rights.</p>

            <h3>1. No Data Collection</h3>
            <p>Cogio does not collect, transmit, or upload any personal or usage data. All your tracked sessions
                stay entirely on your device.</p>

            <h3>2. Local Data Storage</h3>
            <p>Your data (such as session names, timestamps, durations, and categories) is stored locally using a
                secure SQLite database placed in your macOS Documents folder. The app does not connect to external
                servers or cloud services.</p>

            <h3>3. No Third Parties</h3>
            <p>Cogio does not use third-party analytics, ads, crash reporting tools, or any embedded trackers.</p>

            <h3>4. Permissions</h3>
            <p>The app requests permission to access your Documents folder only to store the local database file.
                This is a system-required permission to ensure your session history is saved persistently.</p>

            <h3>5. Your Control</h3>
            <p>You have full control over your data. You can manually back up or delete your session history by
                accessing the database file. Future versions may include export features, but nothing will be shared
                without your explicit action.</p>

            <h3>6. Security Notice</h3>
            <p>While Cogio securely stores your data locally, it does not encrypt it. I recommend using macOS's
                built-in security features like FileVault or Time Machine for added protection.</p>

            <h3>7. Changes to This Policy</h3>
            <p>If I ever update this privacy policy, the changes will be reflected in the app or announced in the
                release notes.</p>

            <h3>8. Contact Me</h3>
            <p>If you have any questions about privacy, reach out to me: </p>
            <LinkedText text={"cagri@mpospirit.com"} href={"mailto:cagri@mpospirit.com"} icon={faEnvelope}></LinkedText>
        </div>
    )
    return (
        <div className="cogio-privacy-policy-page">
            <Cogio rightContent={rightContent}/>
        </div>
    )
}